export const ADMIN_TABLE_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_MS = 300;
